import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title \"Page Not Found\"}}\n\n<NwNavbar />\n\n<ErrorPage>Page not found.</ErrorPage>")